module.exports = __webpack_public_path__ + "img/order-info-img.920f4b6c.png";